module.exports = __webpack_public_path__ + "img/applet-sales3.c7630f73.png";